(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3889],{

/***/ 26447:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro",
      function () {
        return __webpack_require__(52237);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40624:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon-right-arrow.e724f296.svg","height":25,"width":25});

/***/ }),

/***/ 25889:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/line-gray.2a41f7c7.png","height":8,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEV7d3cA7s5HcEz/GDL/FC+MLzciAAAABXRSTlNhEACmbmR3WOMAAAAJcEhZcwAACxMAAAsTAQCanBgAAAARSURBVHicY2BgYGRhZmJgAAAANQALSowucwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 58488:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/white-line.61493d09.png","height":8,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEX/+/z/DSj/FjFHcEz///+TJnfuAAAABXRSTlNhbqYAEH2C6coAAAAJcEhZcwAACxMAAAsTAQCanBgAAAARSURBVHicY2BgYGFkYmZgAAAANwALB9DC7QAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 52237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ astro; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(75083);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/assets/images/Astro-Banner.jpg
/* harmony default export */ var Astro_Banner = ({"src":"/_next/static/media/Astro-Banner.8942e35b.jpg","height":670,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAdEAACAQQDAAAAAAAAAAAAAAABAgADBAUREhMi/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAT/xAAZEQEBAQADAAAAAAAAAAAAAAABAgARIVH/2gAMAwEAAhEDEQA/AJ6zm3x1LqCrzG28g7JWIiVWCHPmVVHQ7//Z"});
;// CONCATENATED MODULE: ./src/assets/images/Daily-Horoscope.jpg
/* harmony default export */ var Daily_Horoscope = ({"src":"/_next/static/media/Daily-Horoscope.32f40dfc.jpg","height":343,"width":514,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABAwMFAAAAAAAAAAAAAAABAAQxAgMFBhESE0L/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABcRAQEBAQAAAAAAAAAAAAAAAAEAAhH/2gAMAwEAAhEDEQA/AInHZFqNMu7bhj28adgRcFMx5MIiKna9jAv/2Q=="});
// EXTERNAL MODULE: ./src/assets/images/icon-right-arrow.svg
var icon_right_arrow = __webpack_require__(40624);
;// CONCATENATED MODULE: ./src/assets/images/Kudili.jpg
/* harmony default export */ var Kudili = ({"src":"/_next/static/media/Kudili.3406f0c0.jpg","height":343,"width":514,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAfEAABAwMFAAAAAAAAAAAAAAAAAQMRBAUhBhITQlH/xAAUAQEAAAAAAAAAAAAAAAAAAAAF/8QAGREAAgMBAAAAAAAAAAAAAAAAAQIAAyER/9oADAMBAAIRAxEAPwCdPaKJ3RzloVrO7kR/smJiPAAHixh3YkyjJ//Z"});
;// CONCATENATED MODULE: ./src/assets/images/Astro-Consultation.jpg
/* harmony default export */ var Astro_Consultation = ({"src":"/_next/static/media/Astro-Consultation.b3f99ac0.jpg","height":343,"width":514,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIDBAURQSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABYRAQEBAAAAAAAAAAAAAAAAAAECAP/aAAwDAQACEQMRAD8Am0OWqmrJGMRUL5HeudsgDXBxERCTWqd//9k="});
// EXTERNAL MODULE: ./src/assets/images/line-gray.png
var line_gray = __webpack_require__(25889);
// EXTERNAL MODULE: ./src/assets/images/white-line.png
var white_line = __webpack_require__(58488);
;// CONCATENATED MODULE: ./src/assets/images/Why-choose-senco-astro.jpg
/* harmony default export */ var Why_choose_senco_astro = ({"src":"/_next/static/media/Why-choose-senco-astro.8e92ff6e.jpg","height":480,"width":572,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAEAAgAHAAAAAAAAAAAAAAABAAIDBAURE0Hx/8QAFAEBAAAAAAAAAAAAAAAAAAAABf/EABgRAAIDAAAAAAAAAAAAAAAAAAACEUFx/9oADAMBAAIRAxEAPwC1cxZ12mGoU4G5t2exEQiRN6w//9k="});
;// CONCATENATED MODULE: ./src/assets/images/astro-main-1.png
/* harmony default export */ var astro_main_1 = ({"src":"/_next/static/media/astro-main-1.3f7666c8.png","height":651,"width":568,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAUVBMVEVHcExVNyhGMh38qjsqJCL/1kjNcyQlISB5SS1TRTpcOCQuAACqezD//5JDMCXzkS3eXSIMEhihSSCYTSahWir/ginndisfFxi2YChILSS7mHiDBmKtAAAAGXRSTlMATBUS+gUWyvz+/AEDAZY+OTbmPTo67+7vked0SQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADtJREFUeJwNx8cBwDAIALED45re4+w/aNBPgIoCMeWaj+C1r4pfn2IbhPS2dkZIdy+Xf9mtrzBOMgvDDy/CAcjO1C/cAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/astro-main-2.png
/* harmony default export */ var astro_main_2 = ({"src":"/_next/static/media/astro-main-2.4efabb0e.png","height":651,"width":575,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAV1BMVEVHcEzz1RCkWjd4OF57RSpGN17Yqqaxh60NAAADAwD//+wdDQysa07Yvcb8UwDMrqnitLT/jTWTYIildad/Y4zCkZLwv8Tl0NEkFAH/xUZaTHJFKiXyydJr17VFAAAAGnRSTlMAAzwhPc0s+xJRAfUX+gr0/hD89Pv3GviYF6yN4voAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA6SURBVHicBcGFAcAwDMAwpynjmP+/cxIQbQSkuseZGXQLixFE1y+o0I/WTt+hjmn3cJvyFpuRnK4EPzqJAggeL0KRAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/styles/Astro.module.scss
var Astro_module = __webpack_require__(10335);
var Astro_module_default = /*#__PURE__*/__webpack_require__.n(Astro_module);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
;// CONCATENATED MODULE: ./src/pages/astro/index.tsx












// import Astrobanner from "@/assets/images/Astro-Banner.jpg.jpg";















swiper_esm/* default.use */.ZP.use([
    swiper_esm/* FreeMode */.Rv,
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Thumbs */.o3
]);
var Astro = function() {
    var ref = (0,react.useState)([]), astro = ref[0], setAstro = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        loadZodiac();
    }, []);
    var loadZodiac = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.astro.zodiacList */.Z.astro.zodiacList());
                    case 3:
                        data = _ctx.sent.data;
                        setAstro(data);
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function loadZodiac() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,react.useState)(null), thumbsSwiper = ref1[0], setThumbsSwiper = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Astro_module_default()).astro_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: Astro_Banner,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Astro_module_default()).astro_bg,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Astro_module_default()).astro_bg_main,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Astro_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Astro_Consultation,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).heading,
                                                    children: "Astro Consultation"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Our astro consultation services are customized to help you gain a deeper understanding of your personal life, health and career."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/astrologers",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Book Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Astro_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Kudili,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).heading,
                                                    children: "Kundli "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Your Janam Kundli or Life Kushti can be the success tool of your life. We also specialize in Kundli Matching services."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/kundali",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Book Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Astro_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Daily_Horoscope,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).heading,
                                                    children: "Daily Horoscope"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Boost your confidence with our Daily Horoscope services based on your zodiac sign. It includes your lucky number and colour as well."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/horoscope",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Check Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Astro_module_default()).about_astro,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                children: "Online Astrological Services"
                                            })
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Astro_module_default()).gline,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: line_gray/* default */.Z,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center",
                                                children: "The customized astrological services offered by Senco Gold & Diamonds aim at bringing harmony in one’s life. We have years of experience in guiding people who are wandering without direction and seeking professional guidance. The objective is to help our customers in the best possible way. Daily horoscope services, Kundli services and Astro Consultation services – we offer it all."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center",
                                                children: "We also offer Career and Business Horoscope services that include career analysis, favourable periods for career, career yoga and favourable periods for business. We will also let you know the auspicious periods and favourable Dasa Periods that will help you succeed in your career/business. You can choose from a wide range of time periods for Kundli services."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center text-dark",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                        children: "A Trusted Name for Astrological Gemstones"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center",
                                                children: "Discover the world of 100% authentic and certified astrological gemstones at Senco Gold & Diamonds. Our precious gemstones have an alluring splendor and unparalleled hues. Our gemstone experts are equipped with comprehensive knowledge and expertise in the identification, grading, and valuation of gemstones. Visit our stores to discuss your planetary gemstone requirements and choose from a wide range of authentic gemstones."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Astro_module_default()).about_astro_main,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).about_astro_main_img,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Why_choose_senco_astro,
                                                        alt: ""
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Astro_module_default()).about_astro_main_heading,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                            children: " Why Choose Senco for Astrological Services?"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: (Astro_module_default()).list,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "A trusted name with years of experience in offering astrological services."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Try to meet and exceed the expectations of our customers."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Continually strive to provide accurate and detailed predictions."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Our astrologers have in-depth and extensive knowledge of the subject."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Let you choose from a wide variety of astrological services at affordable prices."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).about_astro_main_call,
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/contact-us",
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (Astro_module_default()).text_hover,
                                                                    children: "Contact Us "
                                                                })
                                                            }),
                                                            " ",
                                                            "to know more about our Astrological Services"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Astro_module_default()).horoscope_bg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Astro_module_default()).horoscope_astro,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Astro_module_default()).horoscope_astro_head,
                                children: [
                                    "CHECK YOUR ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "HOROSCOPE"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Astro_module_default()).wline,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: white_line/* default */.Z,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center mt-4 mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-center",
                                        children: " Life is full of possibilities."
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Astro_module_default()).icon_container,
                                children: !!astro.length && astro.map(function(v) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Astro_module_default()).col,
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    router.push("/astro/horoscope/".concat(v.name));
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Astro_module_default()).border_full,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (Astro_module_default()).icon_img,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: v.thumbnail_image,
                                                                alt: "",
                                                                height: "200px",
                                                                width: "200px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                v.name,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " ",
                                                                moment_default()(v.start_date).format("MMMM DD"),
                                                                " -",
                                                                moment_default()(v.end_date).format("MMMM DD")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Astro_module_default()).horoscope_bg_row,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: astro_main_1,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img_heading,
                                        children: "Astro Consultation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/astro/astrologers",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Astro_module_default()).horoscope_bg_row_button,
                                            children: "Book Now"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: astro_main_2,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img_heading,
                                        children: "Get Kundli"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/astro/kundali",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Astro_module_default()).horoscope_bg_row_button,
                                            children: "Book Now"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var astro = (Astro);


/***/ }),

/***/ 10335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"astro_banner":"Astro_astro_banner__sDO2M","astro_banner_text":"Astro_astro_banner_text__6DTk4","astro_banner_main":"Astro_astro_banner_main__o0hbF","astro_banner_main_text":"Astro_astro_banner_main_text__x8uh5","astro_bg":"Astro_astro_bg__5NVPX","astro_bg_main":"Astro_astro_bg_main__W1LDZ","custom_card":"Astro_custom_card__3YSWN","heading":"Astro_heading__TFh8B","more":"Astro_more__knWmG","about_astro":"Astro_about_astro__TMR3Z","about_astro_main":"Astro_about_astro_main__6TDgV","about_astro_main_img":"Astro_about_astro_main_img__n86o5","about_astro_main_heading":"Astro_about_astro_main_heading__MV3Bm","about_astro_main_call":"Astro_about_astro_main_call__x6ZEc","call_number":"Astro_call_number__W8kJm","horoscope_bg":"Astro_horoscope_bg__s1cC8","horoscope_astro_head":"Astro_horoscope_astro_head__5r0tj","horoscope_bg_row":"Astro_horoscope_bg_row__0OLXN","horoscope_bg_row_img":"Astro_horoscope_bg_row_img__Tcq6K","horoscope_bg_row_img_heading":"Astro_horoscope_bg_row_img_heading__wLgyr","horoscope_bg_row_button":"Astro_horoscope_bg_row_button__Ba79J","horoscope_bg_row_form":"Astro_horoscope_bg_row_form__aVmQu","horoscope_bg_row_form_head":"Astro_horoscope_bg_row_form_head__lABJU","horoscope_bg_row_form_body":"Astro_horoscope_bg_row_form_body__AuMuo","form_control":"Astro_form_control__DExHL","red_button":"Astro_red_button__uwOGN","horoscope_bg_row_w":"Astro_horoscope_bg_row_w__QXmKl","horoscope_bg_dark":"Astro_horoscope_bg_dark__v1OLp","wline":"Astro_wline__Sbx21","gline":"Astro_gline__YrthE","new_row_st":"Astro_new_row_st__wpP8K","new_row_st_main":"Astro_new_row_st_main__UGOWU","new_row_st_main_text":"Astro_new_row_st_main_text__9vTKn","icon_container":"Astro_icon_container__HgDxd","col":"Astro_col__i7eey","border_full":"Astro_border_full__GUQ2b","icon_img":"Astro_icon_img__pZd8A","list":"Astro_list__DCkVJ","text_hover":"Astro_text_hover__dPnZt","custom_font":"Astro_custom_font__0jTSV"};

/***/ }),

/***/ 30706:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 75083:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(26447); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);